var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackButtonIcon = function SvgBackButtonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16.5h33v1H1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.97 16.97 0l.708.707-16.97 16.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 17.007 16.97 16.97.708-.706L.708 16.3z"
  }))));
};
export default SvgBackButtonIcon;